module.exports = __webpack_public_path__ + "static/media/redux.bdfbec3b.PNG";